import React from 'react';

import SortIcon from 'assets/images/icon/SortIcon';
import styled from 'styled-components';
import { CheckBox } from 'view/components/common/CheckBox';

interface StyledComponentProps {
    width?: string;
}

const ListItem = (props) => {

    return (
        <Container>
            <Col width={"20px"}>
                <div style={{ paddingTop: 1 }}>
                    <CheckBox onClick={props?.onClickCheckbox} state={props?.checkState} />
                </div>
            </Col>
            <Col width={"70px"}>
                <span>Name</span>
                <SortIcon/>
            </Col>
            <Col width={"90px"}>
                <span>Username</span>
                <SortIcon/>
            </Col>
            <Col width={"70px"}>
                <span>Job</span>
                <SortIcon/>
            </Col>
            <Col width={"130px"} style={{}}>
                <span>Email</span>
                <SortIcon/>
            </Col>
      
            <Col width={"70px"}>
                <span>Status</span>
                <SortIcon/>
            </Col>
            <Col width={"90px"}>
                <span>Submitted</span>
                <SortIcon/>
            </Col>
            <Col width={"80px"}>
                <span>Updated</span>
                <SortIcon/>
            </Col>
            <Col width={"70px"}>
                <span>Action</span>
                <SortIcon/>
            </Col>
        </Container>
    );
};
export default ListItem;

const Container = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    padding: 18px 20px;
    border-bottom: solid 1px #e9edf5;

    &::-webkit-scrollbar {
        width: 1px;
        height: 2px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(51, 51, 51, 0.3);
        border: none;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
        border: none;
    }
`;

const Col = styled.div<StyledComponentProps>`
    display: flex;
    align-items: center;
    word-wrap: break-word;
    width: ${(props) => (props.width ? `${props.width}` : "auto")};
    min-width: ${(props) => (props.width ? `${props.width}` : "auto")};
    flex-wrap: wrap;
    /* min-width: ${(props) => (props.width ? `calc(${props.width} / 100%)` : "auto")}; */
    margin: 0 10px;
    justify-content: flex-start;
    &:nth-child(1) {
        margin-left: 0;
        margin-right: 0.5%;
    }
    &:last-child{
        margin-right:0;
    }
    span {
        padding-top: 1px;
        font-size: 14px;
        font-weight: 700;
        color: #333333d5;
    }
`;

const Icons = styled.div`
    display: flex;
    align-items: center;
`;
const Icon = styled.div`
    display: flex;
    align-items: center;
`;
